// @flow
import * as React from 'react';
import { reduxForm } from 'redux-form';
import { RESET_PASSWORD_FORM } from 'constants/forms';

type Options = {
  onSubmit: Function,
};

type Props = {
  nextPage: Function,
}
const connectPasswordResetFormPage = (options: Options) =>
  (FormPage: React.AbstractComponent<Options>) => (props: Props) => {
    const { nextPage, ...rest } = props;
    const ConnectedFormPage = (
      reduxForm({
        onSubmit: (values, dispatch) => options.onSubmit(values, dispatch, nextPage),
        form: RESET_PASSWORD_FORM,
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
      })(FormPage)
    );
    return <ConnectedFormPage {...rest} />;
  };

export default connectPasswordResetFormPage;



// WEBPACK FOOTER //
// ./js/components/pages/ResetPassword/ResetPasswordForm/support/connectPasswordResetFormPage.jsx